
import { PAGE_TYPE, CAMPAIGN_QUERY } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app, error, params: { handle: uid } }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: CAMPAIGN_QUERY,
      variables: { uid, lazy: false },
    });

    if (data?.slices == null ?? data?.slices?.length === 0) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    return {
      uid,
      pageType: PAGE_TYPE,
      slices: data.slices,
      campaignSaleUID: data.campaign_sale_link?._meta?.uid,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
      displayBanner: data.display_banner,
      title: data.title,
    };
  },
};
